import React from "react";
import { Grid } from "@material-ui/core";
import { TextLabel, FeedBackPage } from "../../shared/components";
import { SelectedFarmContainer } from "../../shared/crossCuttingComponents";
import { getMensagemFeedbackFechamento } from "../fechamentoConsumoUtils";
import { t } from "adapters/i18n";
export const FechamentoConsumoFeedback = (props) => {
  return (
    <SelectedFarmContainer
      data-testid="fechamentoConsumoFeedback"
      render={(fazenda) => {
        const msgFeedback = getMensagemFeedbackFechamento(fazenda);

        return (
          <Grid
            container
            direction="column"
            justify="center"
            style={{
              minHeight: "60vh",
            }}
          >
            <FeedBackPage>
              <Grid container direction="column" alignItems="center">
                <img
                  src="../images/fechamentoTelaVazia.png"
                  alt={msgFeedback}
                />
                <TextLabel
                  id="labelFechamentoFeedBack"
                  block
                  color="default2"
                  customStyle={{ paddingTop: 10 }}
                >
                  {t(msgFeedback)}
                </TextLabel>
              </Grid>
            </FeedBackPage>
          </Grid>
        );
      }}
    />
  );
};

export default FechamentoConsumoFeedback;
